import React, { useCallback, useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { DrawerComponent } from 'components/Drawer';
import { api } from 'services/api';
import loadingIcon from 'assets/image/loading.svg';
import * as S from './styles';
import Qualifications from './components/Qualifications';
import CardDrawer from './components/CardDrawer';
import { CaretDoubleUp, DownloadIcon, PhoneInHand, Star, ToolTipIcon } from 'components/Icons';
import moment from 'moment';
import DocumentCheckMark from 'components/Icons/DocumentCheckMark';
import MegaPhone from 'components/Icons/MegaPhone';
import { theme } from 'styles/theme';
import { ToolTip } from 'components/ToolTip';
import { InvoiceStatus } from 'components/InvoiceStatus';
interface IConsumptionDetails {
  closeDrawer: () => void;
  idConsumption: string | undefined;
  indicator: any;
  exceedingLeads:any
}
const ConsumptionDetails = ({
  closeDrawer,
  idConsumption,
  indicator,
  exceedingLeads
}: IConsumptionDetails) => {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [isExporting, setIsExporting] = useState(false);
  const [history, setHistory] = useState<any[]>([]);
  const fetchDataDailyQualification = async () => {
    setIsLoading(true);
    const startDate = moment(
      `${indicator.ano}-${indicator.mes}-01`,
      'YYYY-MM-DD',
    ).format('YYYY-MM-DD');
    let endDate;

    const currentMonth = moment().month() + 1; // Mês atual (1 baseado)
    const currentYear = moment().year(); // Ano atual

    // Verifica se o mês indicado é o mesmo do mês atual
    if (indicator.mes === currentMonth && indicator.ano === currentYear) {
      endDate = moment().format('YYYY-MM-DD'); // Usa o dia de hoje
    } else {
      // Caso contrário, usa o último dia do mês indicado
      endDate = moment(`${indicator.ano}-${indicator.mes}-01`)
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    try {
      const { data } = await api.get(
        `qualifier/movto/debit/${idConsumption}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&limit=${10}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setHistory((prevState) => {
        // Filtra os novos dados para garantir que não haja objetos duplicados
        const filteredData = data.data.filter(
          (newItem: any) =>
            !prevState.some(
              (existingItem) =>
                JSON.stringify(existingItem) === JSON.stringify(newItem),
            ),
        );

        // Adiciona os objetos filtrados ao estado
        return [...prevState, ...filteredData];
      });

      setTotalPages(data.pagination.pages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAllDataForExport = async () => {
    const startDate = moment(
      `${indicator.ano}-${indicator.mes}-01`,
      'YYYY-MM-DD',
    ).format('YYYY-MM-DD');
    let endDate;

    const currentMonth = moment().month() + 1; // Mês atual (1 baseado)
    const currentYear = moment().year(); // Ano atual

    // Verifica se o mês indicado é o mesmo do mês atual
    if (indicator.mes === currentMonth && indicator.ano === currentYear) {
      endDate = moment().format('YYYY-MM-DD'); // Usa o dia de hoje
    } else {
      // Caso contrário, usa o último dia do mês indicado
      endDate = moment(`${indicator.ano}-${indicator.mes}-01`)
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    try {
      const { data } = await api.get(
        `qualifier/movto/debit/${idConsumption}/export?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      return data.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };
  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const allData = await fetchAllDataForExport();

      if (allData.length === 0) {
        alert('Não há dados para exportar');
        return;
      }

      // Preparar os dados para o Excel
      const excelData = allData.map((item: any) => ({
        'Nome do Cliente': item.name_client || '',
        Corretor: item.name_broker || '',
        Pretensão: item.type_pretense_lead || '',
        Data: moment(item.date).format('DD/MM/YYYY HH:mm'),
        'ID Lead': item.id_lead || '',
        'ID Débito': item.id_debit || '',
      }));

      // Criar workbook e worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Definir largura das colunas
      const columnWidths = [
        { wch: 25 }, // Nome do Cliente
        { wch: 20 }, // Corretor
        { wch: 15 }, // Pretensão
        { wch: 18 }, // Data
        { wch: 25 }, // ID Lead
        { wch: 12 }, // ID Débito
      ];
      worksheet['!cols'] = columnWidths;

      // Adicionar worksheet ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads Qualificados');

      // Gerar nome do arquivo
      const monthName =
        moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
          .format('MMMM')
          .charAt(0)
          .toUpperCase() +
        moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
          .format('MMMM')
          .slice(1);

      const fileName = `Leads_Qualificados_${monthName}_${indicator?.ano}.xlsx`;

      // Fazer download do arquivo
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      alert('Erro ao exportar dados. Tente novamente.');
    } finally {
      setIsExporting(false);
    }
  };
  useEffect(() => {
    fetchDataDailyQualification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indicator, idConsumption, currentPage]);

  const Loader = () => {
    return (
      <S.Loader>
        <img src={loadingIcon} width={36} height={36} />
      </S.Loader>
    );
  };

  const [nextPageDiv, setNextPageDiv] = useState<HTMLDivElement | null>(null);
  const showMoreHistory = () => {
    setCurrentPage((indicatorsPerPage) => indicatorsPerPage + 1);
  };
  const nextPageDivCallback = useCallback((node: HTMLDivElement | null) => {
    setNextPageDiv(node);
  }, []);

  useEffect(() => {
    if (!nextPageDiv) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting && currentPage < totalPages) {
          showMoreHistory();
        }
      },
      {
        root: null,
        rootMargin: '20px',
        threshold: 0.1,
      },
    );

    observer.observe(nextPageDiv);

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextPageDiv]);
  return (
    <DrawerComponent
      open
      size="default"
      // className={styles.drawer}
      onCompleteClose={closeDrawer}
      titleClose={'Consumo mensal'}
    >
      {isLoading && currentPage === 1 ? (
        <Loader />
      ) : (
        <>
          <S.WrapperInvoiceDetail>
            <span>
              {moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
                .format('MMMM')
                .charAt(0)
                .toUpperCase() +
                moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
                  .format('MMMM')
                  .slice(1)}{' '}
              de{' '}
              {moment(
                `${indicator?.ano}-${indicator?.mes}-01`,
                'YYYY-MM-DD',
              ).format('YYYY')}
            </span>
          </S.WrapperInvoiceDetail>
          <S.ContentDetails>
            <S.Box>
              <S.TextAside fontSize="16" fontWeight="700">
                {indicator?.tot_leads_qualificados_mes} lead
                {indicator?.tot_leads_qualificados_mes ? 's' : ''} qualificado
                {indicator?.tot_leads_qualificados_mes ? 's' : ''}
              </S.TextAside>
              <S.GridInfos>
                <Qualifications
                  amount={`${indicator?.qtd_leads_qualificados_mes_alto}`}
                  status={'alto'}
                />
                <Qualifications
                  amount={`${indicator?.qtd_leads_qualificados_mes_medio}`}
                  status={'medio'}
                />
                <Qualifications
                  amount={`${indicator?.qtd_leads_qualificados_mes_baixo}`}
                  status={'baixo'}
                />
              </S.GridInfos>
              {indicator.qtd_leads_qualificados_mes_novo_cliente > 0 && (
                <>
                  <hr style={{ margin: '16px -24px' }} />
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <Star />
                    <S.TextCard>
                      {!moment(
                        `${indicator?.ano}-${indicator?.mes}-01`,
                        'YYYY-MM-DD',
                      ).isSame(moment(), 'month')
                        ? ` ${indicator.qtd_leads_qualificados_mes_novo_cliente} leads não foram qualificados até o fim do mês.`
                        : `O potencial está em análise para ${indicator.qtd_leads_qualificados_mes_novo_cliente} leads.`}
                    </S.TextCard>
                  </div>
                </>
              )}
            </S.Box>
            {!moment(
              `${indicator?.ano}-${indicator?.mes}-01`,
              'YYYY-MM-DD',
            ).isSame(moment(), 'month') && (
              <S.Box>
                <S.TextAside fontSize="16" fontWeight="700">
                  Desempenho
                </S.TextAside>
                <S.GridPerfomace>
                  <S.Performance>
                    <DocumentCheckMark />
                    <S.Status>
                      <S.RowPerformance marginBottom="1rem">
                        <S.TitlePerfomace
                          color={theme.colors.neutral.neutral120}
                          fontWeight={600}
                          fontSize="2rem"
                        >
                          {
                            indicator?.perc_contratos_fechados_alto_potencial_mes_atual
                          }
                          %
                        </S.TitlePerfomace>
                      </S.RowPerformance>
                      <S.SubtitlePerfomace
                        color={theme.colors.neutral.neutral120}
                        fontWeight={500}
                      >
                        dos contratos fechados são de leads quentes.
                      </S.SubtitlePerfomace>
                    </S.Status>
                  </S.Performance>
                  <S.Performance>
                    <MegaPhone />
                    <S.Status>
                      <S.RowPerformance marginBottom="1rem">
                        <S.TitlePerfomace
                          color={theme.colors.neutral.neutral120}
                          fontWeight={600}
                          fontSize="2rem"
                        >
                          {
                            indicator?.perc_cliente_alto_potencial_originacao_propria_mes_atual
                          }
                          %
                        </S.TitlePerfomace>
                      </S.RowPerformance>
                      <S.SubtitlePerfomace
                        color={theme.colors.neutral.neutral120}
                        fontWeight={500}
                      >
                        dos leads quentes vieram de originação própria.
                      </S.SubtitlePerfomace>
                    </S.Status>
                  </S.Performance>
                </S.GridPerfomace>
              </S.Box>
            )}
            <S.TextAside
              fontSize="16"
              fontWeight="700"
              style={{ marginBottom: '16px' }}
            >
              Saldo recebido
            </S.TextAside>
            <S.Box>
              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                  justifyContent: 'space-between',
                }}
              >
                {' '}
                <S.TextAside fontSize="16" fontWeight="500">
                  Leads do plano
                </S.TextAside>{' '}
                <S.TextAside fontSize="16" fontWeight="700">
                <InvoiceStatus
                  status={"venda"}
                  text={indicator?.qtd_creditos_recebidos}
                  icon={<CaretDoubleUp />}
                  colortText={
                  theme.colors.neutral.neutral120
                  }
                  fontWeight="500"
                />
                </S.TextAside>
              </div>
       {(indicator.mes === moment().month() + 1 ? exceedingLeads : indicator?.qtd_debitos_negativos)>0 ?   <>    <hr style={{ margin: '16px -24px' }} />
              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                  justifyContent: 'space-between',
                }}
              >
                {' '}
                <S.TextAside fontSize="16" fontWeight="500">
                  Leads pós-pagos
                </S.TextAside>{' '}
                <S.TextAside fontSize="16" fontWeight="700">
                  <InvoiceStatus
                    status={"venda"}
                    text={indicator.mes === moment().month() + 1 ? exceedingLeads : indicator?.qtd_debitos_negativos}
                    icon={<CaretDoubleUp />}
                    colortText={
                    theme.colors.neutral.neutral120
                    }
                    fontWeight="500"
                  />
                </S.TextAside>
              </div></> : <></>}
            </S.Box>
            <div
              style={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'space-between',
                marginBottom: '16px',
              }}
            >
              <S.TextAside fontSize="16" fontWeight="700" style={{display: "flex", gap:"8px"}}>
                Leads qualificados  <ToolTip
                  content={"O Kenlo Leads qualifica por atendimento. Cada atendimento gera uma qualificação e consome saldo, mesmo que seja para o mesmo cliente."}
                  icon={
                   <ToolTipIcon /> 
                  }
                />
              </S.TextAside>
              <span
                onClick={isExporting || history.length <= 0 ? undefined : exportToExcel}
                style={{
                  color: isExporting || history.length <= 0
                    ? theme.colors.neutral.neutral50
                    : theme.colors.primary50,
                  cursor: isExporting || history.length <= 0 ? 'not-allowed' : 'pointer',
                  opacity: isExporting || history.length <= 0 ? 0.6 : 1,
                  pointerEvents: isExporting || history.length <= 0 ? 'none' : 'auto',
                  fontSize: '16px !important',
                }}
              >
                <ToolTip
                  right="2rem"
                  height="3rem"
                  content={
                    isExporting
                      ? 'Download em andamento, aguarde...'
                      : 'Apenas nome do cliente, corretor e pretensão serão exportados. Para ver a qualificação atualizada, use esta tela ou a área de atendimentos.'
                  }
                  icon={
                    <div style={{ marginLeft: '1rem' }}>
                      {isExporting ? <S.LoadingSpinner /> : <DownloadIcon />}
                    </div>
                  }
                  text={isExporting ? 'Exportando...' : 'Exportar'}
                />
              </span>
            </div>
            <S.Box>
              {history.length > 0 ? (
                history.map((el, index) => (
                  <>
                    <CardDrawer
                      key={el?.id_debit}
                      name={el?.name_client}
                      status={el?.potential}
                      operation={el?.type_pretense_lead}
                      broker={el?.name_broker}
                      href={el?.url_esteira}
                      potentialOrigin={el?.potential_origin}
                    />

                    {index !== history.length - 1 && (
                      <hr style={{ margin: '16px -24px' }} />
                    )}
                  </>
                ))
              ) : (
                <S.NotLeads>
                  <PhoneInHand />
                  <div>
                    <S.TitlePerfomace
                      color={theme.colors.neutral.neutral120}
                      fontWeight={600}
                      fontSize="2rem"
                      style={{ marginBottom: '8px' }}
                    >
                      Nenhum lead esse mês
                    </S.TitlePerfomace>
                    <S.SubtitlePerfomace
                      color={theme.colors.neutral.neutral120}
                      fontWeight={500}
                    >
                      Com a transferênca automática você recebe leads mais
                      rápido.
                    </S.SubtitlePerfomace>
                  </div>
                </S.NotLeads>
              )}
            </S.Box>
            <div ref={nextPageDivCallback} />
          </S.ContentDetails>
        </>
      )}
    </DrawerComponent>
  );
};
export default ConsumptionDetails;
